module.exports = __webpack_public_path__ + "img/icon_mechatronics.7ac7232.svg";